import { StaticImageData } from 'next/image';
import LBreakDownIcon from '../../public/images/benefits/light/breakdown.svg';
import LServiceIcon from '../../public/images/benefits/light/service.svg';
import LConsumablesIcon from '../../public/images/benefits/light/consumables.svg';
import LSparesIcon from '../../public/images/benefits/light/spares.svg';
import LDiscountIcon from '../../public/images/benefits/light/discount.svg';
import LPeaceOfMindIcon from '../../public/images/benefits/light/peaceOfMind.svg';

import DBreakDownIcon from '../../public/images/benefits/dark/breakdown.svg';
import DServiceIcon from '../../public/images/benefits/dark/service.svg';
import DConsumablesIcon from '../../public/images/benefits/dark/consumables.svg';
import DSparesIcon from '../../public/images/benefits/dark/spares.svg';
import DDiscountIcon from '../../public/images/benefits/dark/discount.svg';
import DPeaceOfMindIcon from '../../public/images/benefits/dark/peaceOfMind.svg';
import dlv from 'dlv';

export const accordionData = [
  {
    question: 'How AMC works?',
    answers: [
      {
        id: 0,
        desc: 'Select the AMC plan that best fits your needs and budget.',
      },
      {
        id: 1,
        desc: 'Schedule regular maintenance visits at your convenience.',
      },
      {
        id: 2,
        desc: "Relax knowing that your water purifier is in expert hands and that you'll have access to prompt repair services if needed.",
      },
    ],
  },
  {
    question: 'What does the AMC plan cover?',
    answers: [
      {
        id: 0,
        desc: 'Our AMC plans typically cover routine maintenance, which includes one-time filter replacement, deep cleaning, and parts inspection, as well as repair services in case of a breakdown or malfunction.',
      },
    ],
  },
  {
    question: `What happens when I don't opt for an AMC plan?`,
    answers: [
      {
        id: 0,
        desc: 'Without an AMC plan, your purifier may lack regular maintenance, impacting its efficiency. Opting for an AMC ensures peace of mind, preventing surprise costs and prioritizing the safety and well-being of your family by maintaining a consistently effective purifier.',
      },
    ],
  },
  {
    question: 'How often should I get my water purifier serviced under the AMC plan?',
    answers: [
      {
        id: 0,
        desc: 'The frequency of servicing your water purifier depends on factors such as water consumption and the input quality of water. For personalized guidance, we recommend connecting with our service technicians, by booking through the Eureka Forbes App.',
      },
    ],
  },
  {
    question: 'Are there any additional charges for repair services under the AMC plan?',
    answers: [
      {
        id: 0,
        desc: 'All electrical and electronics parts and free preventative services are covered under AMC. However, charges may apply for additional filters or consumable changes as per your AMC plan. For detailed information or to purchase an AMC, you can download the Eureka Forbes App.',
      },
    ],
  },
];

export type iconMapType = {
  [key: string]: StaticImageData;
};

export const LightBenefitIconMap: iconMapType = {
  breakdown: LBreakDownIcon,
  service: LServiceIcon,
  consumables: LConsumablesIcon,
  spares: LSparesIcon,
  discount: LDiscountIcon,
  peaceOfMind: LPeaceOfMindIcon,
};

export const DarkBenefitIconMap: iconMapType = {
  breakdown: DBreakDownIcon,
  service: DServiceIcon,
  consumables: DConsumablesIcon,
  spares: DSparesIcon,
  discount: DDiscountIcon,
  peaceOfMind: DPeaceOfMindIcon,
};

export const transformHeaderItems = (items: any[]) =>
  items?.map((item: any) => {
    item.icon = dlv(
      item,
      'icon.data.attributes.formats.thumbnail.url',
      dlv(item, 'icon.data.attributes.url'),
    );
    return item;
  });

export async function ScaBridge(type: string, metadata: any) {
  if (window && window.ScaBridge && window.ScaBridge.postMessage) {
    window.ScaBridge.postMessage(JSON.stringify({ type, metadata }));
  } else {
    console.log('ScaBridge not available', { type, metadata });
  }
}
